import controller from "./analyticsDashboards.controller";

/* analyticsDashboards.component.js */

/**
 * @desc component for Analytics Dashboards
 * @example <analytics-dashboards></analytics-dashboards>
 */

const analyticsDashboards = {
    controller: controller,
    controllerAs: 'advm',
    templateUrl: '/App/Components/analyticsDashboards/analyticsDashboards.html'
};

export default analyticsDashboards;